/**
 * web/src/screens/Notebook/dates.tsx — the Vault half of the Date Planner:
 * the date-idea pool strip on the Date tile (card vncVrGk1hc9i: moved out of
 * index.tsx unchanged).
 */
import { Pressable } from '../../ui/Pressable';
import { SkeletonBlock } from '../../ui/Skeleton';
import { type NotebookState } from './hooks';
import { dateMeta } from './types';

export function DatePool({ s }: { s: NotebookState }) {
  const { collection, dateIdeas, busyId, sendDate, onOpenDates } = s;
  return (
    <>
        {/* The Vault half of the Date Planner (card ZdYBVP203b8a, PRD §6.1).
            A date idea saved on this tile lands in the couple's POOL — the
            same DateIdea Us → Dates plans from — so the tile shows where it
            went, with the provenance line the PRD asks for and the one action
            that moves an idea into the decision loop. */}
        {collection === 'date' && (
          <section className="nb-dates" id="nb-dates" aria-label="Your date ideas">
            <h3 className="nb-dates-head">Your date ideas</h3>
            {dateIdeas === null ? (
              <SkeletonBlock lines={2} />
            ) : dateIdeas.every(d => d.state !== 'pool') ? (
              <p className="nb-empty" id="nb-dates-empty">
                Nothing waiting — save one above and it comes up the next time you plan together.
              </p>
            ) : (
              <ul className="nb-dates-list" id="nb-dates-pool">
                {dateIdeas.filter(d => d.state === 'pool').map(d => (
                  <li className="nb-date-row" key={d.ideaId} data-idea={d.ideaId}>
                    <div className="nb-date-main">
                      <p className="nb-date-title">{d.title}</p>
                      {d.note && <p className="nb-date-note">{d.note}</p>}
                      <p className="nb-date-meta">
                        {dateMeta(d)}{d.provenance ? ` · ${d.provenance}` : ''}
                      </p>
                    </div>
                    <Pressable
                      className="pear-btn pear-btn-blush nb-date-send"
                      disabled={busyId === d.ideaId}
                      onClick={() => void sendDate(d.ideaId)}
                    >
                      Send to partner
                    </Pressable>
                  </li>
                ))}
              </ul>
            )}
            {/* Card anKalYfYvokw: the old sentence described the route; this is
                the route. Planning lives in Us → Dates, so the footnote opens
                it rather than telling the person to go and find it. */}
            <p className="nb-dates-foot">
              <button
                type="button"
                className="nb-dates-foot-link"
                data-test="nb-dates-foot-link"
                onClick={onOpenDates}
              >
                Planning happens in Us → Dates
              </button>
            </p>
          </section>
        )}
    </>
  );
}
